import { ClaimsDetailsInitialState } from '../models/claimListModel';
import * as types from '../types/claimListTypes';

const initialState: ClaimsDetailsInitialState = {
    payerId: null,
    providerId: null,
    hospActionId: null,
    payerClaimNo: null,
    providerName: null,
};

const claimDetailInitialReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case types.SET_ROW_DETAILS:
            return {
                ...state,
                payerId: action.payload.payerId,
                providerId: action.payload.providerId,
                hospActionId: action.payload.hospActionId,
                payerClaimNo: action.payload.payerClaimNo,
                providerName: action.payload.providerName,
            };
        default:
            return state;
    }
};

export default claimDetailInitialReducer;
